var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.594 17.892l-.892-1.054c0-.027-1.216-1.46-2.08-2.325-.866-.864-2.055-1.756-2.082-1.756l.973-1.298c.054.027 1.297.973 2.27 1.92.433.432.92.972 1.325 1.432.486-1.054 1.243-2.568 2.135-3.865 1.486-2.108 3.189-3.757 3.27-3.811l1.135 1.162c-.027.027-1.675 1.622-3.08 3.595-1.38 1.946-2.46 4.703-2.487 4.73l-.487 1.27z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.054 0C9.351 2.919 3 2.973 3 2.973v12.54C3 20.623 12.054 24 12.054 24s9.054-3.378 9.054-8.486V2.973S14.757 2.919 12.054 0zm7.703 14.973c0 4.351-7.676 7.19-7.676 7.19s-7.703-2.839-7.703-7.19V4.324s5.406-.027 7.676-2.513c2.297 2.486 7.703 2.513 7.703 2.513v10.649z",
    fill: "#000"
  })));
}
export default SvgTrustIcon;